module.exports = "pegasus_template/assets/blocks/image-4-theme3.png";